// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import iview from 'iview'
import 'iview/dist/styles/iview.css'
import store from './stores/store.js' // 状态存储
import _http from './utils/http' // 自定义http
import axios from 'axios'
import i18n from './assets/i18n/i18n'
import '../static/css/table.css'
import './assets/iconfont/iconfont.css'




Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Element)
Vue.use(iview)
Vue.use(_http)
Vue.prototype.$axios=axios
Vue.prototype._i18n = i18n


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    // return originalPush.call(this, location)
  return originalPush.call(this, location).catch(err => err)
}

const has = Vue.directive('has', {
  bind: function(el, binding) {
    let className = binding.value.class;
    if (!Vue.prototype.$_has(className)) {
      //el.parentNode.removeChild(el)
      el.style.display = 'none';
      el.dataset['isRemove'] = '1';
    }
  },
  inserted: function (el) {
    if(el.dataset['isRemove']=== '1'){
      el.parentNode.removeChild(el);
    }
  }
})

Vue.prototype.$_has = function(value) {
  let isExist=false;
  let buttonpermsStr =sessionStorage.getItem("userRolePerm");
  let buttonperms=JSON.parse(buttonpermsStr);
  if(buttonperms==undefined || buttonperms==null){
    return false;
  }
  for(let i=0;i<buttonperms.length;i++){
    if(buttonperms[i].indexOf(value)>-1){
      isExist=true;
      break;
    }
  }
  return isExist;
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      transitionName: 'slide'
    }
  },
  router,
  store,
  i18n,
  has,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js